import React, {useEffect, useState} from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useHistory, useParams} from 'react-router-dom';
import {usePaymentInputs} from 'react-payment-inputs';
import images from 'react-payment-inputs/images';
import './credit-card.scss';
import PayButton from '../../../components/PayButton';
import {orderPaidTotal, orderToPay, orderTotal} from '../../../redux/selectors/order';
import {
  setClientPaymentData,
  submitDejavooWebPayment,
  submitWebPayment
} from '../../../redux/actions/webPayActions';
import {withTranslation} from 'react-i18next';
import IPosModal from '../../../IPosModal';
import ZCreditWebCheckoutIframe from '../../payment/components/ZcreditWebCheckoutIframe';

function* range(start, end, step) {
  while (start < end) {
    yield start;
    start += step;
  }
}

function CreditCard({
                      clientPaymentData,
                      branchInfo,
                      submitWebPayment,
                      submitDejavooWebPayment,
                      clientPaymentAmount,
                      clientTips,
                      t,
                      toPayAmount,
                      payedAmount,
                      setClientPaymentData
                    }) {
  const {orderId} = useParams();
  const history = useHistory();
  const [dejavooIframeUrl, setDejavooIframeUrl] = useState(null);
  const { is_zcreditwc_flg } = branchInfo;

  const ERROR_MESSAGES = {
    emptyCardNumber: t('payment.credit_card.errors.empty_card_number'),
    invalidCardNumber: t('payment.credit_card.errors.invalid_card_number'),
    emptyExpiryDate: t('payment.credit_card.errors.empty_expiry_date'),
    monthOutOfRange: t('payment.credit_card.errors.month_out_of_range'),
    yearOutOfRange: t('payment.credit_card.errors.year_out_of_range'),
    dateOutOfRange: t('payment.credit_card.errors.date_out_o_range'),
    invalidExpiryDate: t('payment.credit_card.errors.invalid_expiry_date'),
    emptyCVC: t('payment.credit_card.errors.empty_cvc'),
    invalidCVC: t('payment.credit_card.errors.invalid_cvc')
  };

  const [data, setData] = useState(clientPaymentData);

  const {
    meta,
    getCardImageProps,
    getCardNumberProps,
    getCVCProps,
  } = usePaymentInputs({errorMessages: ERROR_MESSAGES});

  const handleInputChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value,
    });
  };

  const formatError = (message) => {
    return (
        <div>
          <div>{message}</div>
        </div>
    );
  };

  useEffect(() => {
    const load = async () => {
      if (is_zcreditwc_flg === 1 && orderId) {
        const sessionInfo = await submitDejavooWebPayment(orderId);

        if (!sessionInfo || sessionInfo.error_message) {
          IPosModal.alert({
            title: "",
            message: formatError(
              !sessionInfo ? "Something went wrong" : sessionInfo.error_message
            ),
            okButtonText: t("buttons.ok"),
            onOk: () => {},
          });
          return;
        }

        // const sessionInfo = { SessionUrl: 'https://pci.zcredit.co.il/WebCheckout/Angular/Checkout.html?G=5d4e6528a7#!/ZCreditWebCheckout/5d4e6528a7cb891e521790a5663d36fb7b55b2cb0b03c3c5444b865b80e6c9e5' };

        // setDejavooIframeUrl(sessionInfo.SessionUrl);

        window.location = sessionInfo.SessionUrl;
      }
    };
    load();
  }, [is_zcreditwc_flg, orderId]);

  const handlePassportChange = (e) => {
    const {value} = e.currentTarget;
    const max = 10;
    const currentLength = value.length;
    if (currentLength < max && (value === '' || /^[0-9]+$/.test(value))) {
      handleInputChange(e);
    }
  };

  const handleMobileChange = (e) => {
    const {value} = e.currentTarget;
    const max = 11;
    const currentLength = value.length;
    if (currentLength < max && (value === '' || /^[0-9]+$/.test(value))) {
      handleInputChange(e);
    }
  };

  const onSuccessfulPayment = () => {
      IPosModal.alert({
        iconName: 'check-circle',
        title: t('web_pay.messages.success_title'),
        message: t('web_pay.messages.success_message'),
        okButtonText: t('buttons.ok'),
        cancelButtonText: t('buttons.cancel'),
        onOk: () => {
          history.push(`/${branchInfo.branch_guid_code}/invoice/${orderId}`);
        }
      });
  };

  const onPayClick = async () => {
    setClientPaymentData(data);
    // history.push(`/${branchInfo.branch_guid_code}/invoice/${orderId}/tips`);
    const res = await submitWebPayment(orderId);

    if (res.error_message) {
      IPosModal.alert({
        title: t('web_pay.messages.general_error_title'),
        message: res.error_message,
        okButtonText: t('buttons.ok'),
        cancelButtonText: t('buttons.cancel'),
        onOk: () => {

        }
      });
      return;
    }

    if (res.errors && res.errors.length > 0) {
      for (let i = 0; i < res.errors.length; i++) {
        const msg = res.errors[i];

        IPosModal.alert({
          title: '',
          message: msg.message,
          okButtonText: t('buttons.ok'),
          cancelButtonText: t('buttons.cancel'),
          onOk: () => {

          }
        });
      }
      return;
    }

    if (res.errors && res.errors.length === 0) {
      IPosModal.alert({
        iconName: 'check-circle',
        title: t('web_pay.messages.success_title'),
        message: t('web_pay.messages.success_message'),
        okButtonText: t('buttons.ok'),
        cancelButtonText: t('buttons.cancel'),
        onOk: () => {

        }
      });
    }

    history.push(`/${branchInfo.branch_guid_code}/invoice/${orderId}`);
  };

  if (is_zcreditwc_flg === 1) {
    return (
      <div className="credit-card-payment">
        <div className="credit-card-label">{t('web_pay.credit_card.title')}</div>
        { dejavooIframeUrl && (
            <ZCreditWebCheckoutIframe iframeUrl={ dejavooIframeUrl } onSuccessCallback={ onSuccessfulPayment } />
        ) }
      </div>
    );
  }

  return (
      <div className="credit-card-payment">
      <div className="credit-card-label">{t('web_pay.credit_card.title')}</div>
      <div className="credit-card-inputs">
        <form
          className="card-form" onSubmit={ () => {
        } }>
          <div className="form-input required card-number">
            <div className="input-with-image">
              <svg { ...getCardImageProps({images}) } />
              <input
                { ...getCardNumberProps({
                  placeholder: t('payment.credit_card.labels.card_number'),
                  onChange: handleInputChange,
                  value: data.cardNumber
                }) }
              />
            </div>
            {meta.touchedInputs.cardNumber && meta.erroredInputs.cardNumber && (
              <div className="input-error">
                <span>{meta.erroredInputs.cardNumber}</span>
              </div>
            )}

          </div>

          <div className="form-row">
            <div className="form-input required">
              {/*<label htmlFor="apartment">Expiry Date</label>*/}
              <div className="expiry-date-block">
                <select
                  className="expiryMonth"
                  name="expiryMonth"
                  onChange={ handleInputChange }
                  value={ data.expiryMonth }
                >
                  {Array.from(range(1, 13, 1)).map(number => (
                    <option value={ number }>{number}</option>
                  ))}
                </select>
                <div className="divider">/</div>
                <select
                  className=""
                  name="expiryYear"
                  onChange={ handleInputChange }
                  value={ data.expiryYear }
                >
                  {
                    Array.from(range(new Date().getFullYear(), new Date().getFullYear() + 10, 1))
                      .map(number => (
                        <option value={ number }>{number}</option>
                      ))
                  }
                </select>
              </div>
            </div>
            <div className="form-input required cvc">
              {/*<label htmlFor="apartment">CVC</label>*/}
              <input
                { ...getCVCProps({
                  placeholder: t('payment.credit_card.labels.cvc'),
                  onChange: handleInputChange,
                  value: data.cvc
                }) } />
              {meta.touchedInputs.cvc && meta.erroredInputs.cvc && (
                <div className="input-error">
                  <span>{meta.erroredInputs.cvc}</span>
                </div>
              )}
            </div>
          </div>

          <div className="form-input required passport-block">
            {/*<label htmlFor="cardNumber">Passport</label>*/}
            <input
              type="tel"
              name="passport"
              className="passport-input"
              maxLength={ 10 }
              placeholder={ t('payment.credit_card.placeholders.passport') }
              onChange={ handlePassportChange }
              value={ data.passport }
            />
          </div>

          <div className="form-input required passport-block">
            {/*<label htmlFor="cardNumber">Passport</label>*/}
            <input
              type="tel"
              name="phone"
              className="phone-input"
              maxLength={ 10 }
              placeholder={ t('web_pay.credit_card.phone_placeholder') }
              onChange={ handleMobileChange }
              value={ data.phone }
            />
          </div>

          {/*<div>{meta.isTouched && meta.error && <span>Error: {meta.error}</span>}</div>*/}
        </form>

      </div>
      <div className="actions">
        <PayButton
          price={ clientPaymentAmount + ((clientTips || 0) * 100) }
          text={ t('web_pay.buttons.pay') }
          disabled={ !(data.cardNumber && data.expiryMonth && data.expiryYear && data.cvc && data.passport && data.phone && data.phone.length === 10) }
          onClick={ onPayClick } />
      </div>

    </div>
  );
}

const mapStateToProps = (state) => {
  const {
    branchInfo,
    clientPaymentData,
    clientPaymentAmount,
    clientTips
  } = state;

  return {
    branchInfo,
    clientPaymentData,
    clientPaymentAmount,
    clientTips,
    totalAmount: orderTotal(state),
    payedAmount: orderPaidTotal(state),
    toPayAmount: orderToPay(state)
  };
};

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    submitWebPayment,
    setClientPaymentData,
    submitDejavooWebPayment
  },
  dispatch,
);

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(CreditCard));
